import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/documentNode';
import * as Apollo from '@apollo/client';
import process from 'process';
export type BoardsPageTemplatePickerFragment = (
  { __typename: 'Member' }
  & Pick<Types.Member, 'id' | 'oneTimeMessagesDismissed'>
);

export const BoardsPageTemplatePickerFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BoardsPageTemplatePicker' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Member' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'oneTimeMessagesDismissed' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

interface UseBoardsPageTemplatePickerFragmentOptions
  extends Omit<
    Apollo.UseFragmentOptions<
      BoardsPageTemplatePickerFragment,
      Apollo.OperationVariables
    >,
    'fragment' | 'fragmentName' | 'from'
  > {
  from: Apollo.StoreObject | Apollo.Reference;
  returnPartialData?: boolean;
}

interface UseBoardsPageTemplatePickerFragmentResult
  extends Omit<
    Apollo.UseFragmentResult<BoardsPageTemplatePickerFragment>,
    'data'
  > {
  data?: BoardsPageTemplatePickerFragment;
}

export const useBoardsPageTemplatePickerFragment = ({
  from,
  returnPartialData,
  ...options
}: UseBoardsPageTemplatePickerFragmentOptions): UseBoardsPageTemplatePickerFragmentResult => {
  const result = Apollo.useFragment<BoardsPageTemplatePickerFragment>({
    ...options,
    fragment: BoardsPageTemplatePickerFragmentDoc,
    fragmentName: 'BoardsPageTemplatePicker',
    from: {
      __typename: 'Member',
      ...from,
    },
  });

  // Ensure that the fragment result is not typed as a DeepPartial.
  if (!result.complete && !returnPartialData) {
    if (process.env.NODE_ENV === 'development') {
      if (
        localStorage.getItem('HIDE_FRAGMENT_WARNINGS') === 'false' ||
        localStorage.getItem('HIDE_FRAGMENT_WARNINGS') === null
      ) {
        console.warn('Fragment data is incomplete.', result);
      }
    }
    return {
      ...result,
      data: undefined,
    };
  }

  return { ...result, data: result.data as BoardsPageTemplatePickerFragment };
};
